import React, { Component } from 'react';
import PropTypes from 'prop-types';

import {
  USER_ROLE_RENTER,
} from 'common/userRoles';

import {
  TOUR_CANCEL_REASON_USER_PROVIDED,
  TOUR_CANCEL_REASON_USER_RELATED_OPTION_ITEMS,
  TOUR_CANCEL_REASON_USER_RESCHEDULE_TIME_UNKNOWN,
} from 'common/tourConstants';

import { SCREEN_ID_TOUR_CANCELLATION } from 'client/constants/screenIds';
import {
  SR_API_ACTION_CANCEL_TOUR,
  SR_API_ACTION_ADMIN_MARK_TOUR_NEEDS_RESCHEDULING,
} from 'api/actionTypes';

import withTransitionHook from 'client/helpers/withTransitionHook';
import withScreenId from 'client/helpers/withScreenId';
import withApiState from 'client/helpers/withApiState';
import allowedRoles from 'client/helpers/allowedRoles';

import H1 from 'client/components/H1';
import Navbar from 'client/components/Navbar';
import BackButton from 'client/components/BackButton';
import SrCheckboxList from 'client/components/SrCheckboxList';
import InputText from 'client/components/InputText';
import ButtonDeprecated from 'client/components/ButtonDeprecated';

import { Tour } from 'client/actions';
import postWithState from 'client/actions/postWithState';
import branch from 'client/core/branch';

@withTransitionHook
@allowedRoles({
  roles: [
    USER_ROLE_RENTER,
  ],
  redirectUrl: '/login',
  addRedirectQueryParam: true,
})

@withApiState({
  cancelTourApiState: {
    action: SR_API_ACTION_CANCEL_TOUR,
  },
})
@withScreenId(SCREEN_ID_TOUR_CANCELLATION)
@branch({})
class TourCancellation extends Component {
  static propTypes = {
    cancelTourApiState: PropTypes.object.isRequired,
    lastLocation: PropTypes.object,
  }

  static getPageMetadata = () => ({
    pageTitle: 'Sunroom Rentals',
    section: 'Cancel Tour',
    // canonical: '/',
    keywords: 'rent, home, austin, tour, apartment',
    description: (
      'Spend less time scheduling tours, our rental experts ' +
      'will schedule and confirm tours for you.'
    ),
  })

  constructor(props) {
    super(props);

    this.state = {
      tourCancelReason: '',
      cancelReasonUserProvided: '',
    };
  }

  _onBack = () => {
    const { history, lastLocation } = this.props;
    history.push(lastLocation && lastLocation.pathname || '/tour');
  }

  _onChangeTourReasonOption = (tourCancelReason) => {
    this.setState({
      tourCancelReason,
      cancelReasonUserProvided: '',
    });
  }

  _onChangeTourReasonText = (evt) => {
    this.setState({
      cancelReasonUserProvided: evt.target.value,
      tourCancelReason: '',
    });
  }

  _onCancelTour = () => {
    const { dispatch, match, history } = this.props;
    const { tourCancelReason, cancelReasonUserProvided } = this.state;
    if (tourCancelReason === TOUR_CANCEL_REASON_USER_RESCHEDULE_TIME_UNKNOWN) {
      dispatch(postWithState, {
        action: SR_API_ACTION_ADMIN_MARK_TOUR_NEEDS_RESCHEDULING,
        payload: {
          tourId: parseInt(match.params.tourId, 10),
        },
      }).then(() => {
        history.push('/tour');
      });
    }
    else {
      dispatch(Tour.cancelTour, {
        tourId: parseInt(match.params.tourId, 10),
        ...(cancelReasonUserProvided
          ? { tourCancelReason: TOUR_CANCEL_REASON_USER_PROVIDED, cancelReasonUserProvided }
          : { tourCancelReason }),
      });
    }
  }

  render() {
    const { tourCancelReason, cancelReasonUserProvided } = this.state;
    const { cancelTourApiState } = this.props;

    return (
      <div className='page-tours'>
        <Navbar leftButton={<BackButton onClick={this._onBack} />} />
        <div className='stepContainer'>
          <H1>Why do you want to cancel the tour?</H1>

          <SrCheckboxList
            optionList={TOUR_CANCEL_REASON_USER_RELATED_OPTION_ITEMS}
            onChange={this._onChangeTourReasonOption}
            value={tourCancelReason}
            multipleSelection={false}
          />
          <InputText
            className='choice'
            placeholder='Other...'
            onChange={this._onChangeTourReasonText}
            type='text'
            value={cancelReasonUserProvided}
          />
          <ButtonDeprecated
            disabled={(!tourCancelReason && !cancelReasonUserProvided) || cancelTourApiState.inProgress}
            onClick={this._onCancelTour}
          >
            cancel tour
          </ButtonDeprecated>
        </div>
      </div>
    );
  }
}

TourCancellation.displayName = 'TourCancellation';

export default TourCancellation;
